import { FEATURE_BLOCKS } from '@/config/features';
import { CategoryMenu } from '@/components/common/CategoryMenu';

const PROJECT_IDS = ['crm', 'sale', 'acceptance'];
const items = FEATURE_BLOCKS.filter((b) => PROJECT_IDS.includes(b.id));

export function ProjectCategoryPage() {
  return <CategoryMenu title="專案管理" description="專案相關功能" items={items} />;
}
